import { List, ListItem, Stack } from '@mui/material';
import React from 'react';
import Icon from '@mdi/react';
import { mdiArrowRight, mdiHistory, mdiNewBox } from '@mdi/js';
import GroupedAvatars from '../../GroupedAvatars/GroupedAvatars';
import MainField from '../../TextBlocks/MainField';
import DateTag from '../../TextBlocks/DateTag';
import { vars } from '../../../../Theme';
import { genObjectId } from '../../../../util/HashUtils';
import { parseDate } from '../../../../util/DateUtils';
import { IActivityLogConfig } from '../../../../redux/project/sliceProjectSidepanel';
import i18n from '../../../../localization/i18n';

const itemSx = { p: 0, my: 1, borderBottom: '1px solid black' };

export default ({
    data,
    config,
}: {
    data: IActivityLogActivity[];
    config: IActivityLogConfig[];
}) => (
    <List sx={{ p: 0, overflowY: 'auto' }}>
        {(data ?? []).map(item => {
            const fieldConfig = config.find(x => x.Name === item.Fieldname);
            return (
                <ListItem key={genObjectId(item)} sx={itemSx}>
                    <Stack spacing={1} width='100%'>
                        <Stack direction='row' justifyContent={'space-between'}>
                            <Stack direction='row' pl={0.5} spacing={2}>
                                {fieldConfig?.Icon && (
                                    <Icon
                                        path={fieldConfig?.Icon}
                                        size={1}
                                        style={{ minWidth: '24px' }}
                                        color={vars.font}
                                    />
                                )}
                                <MainField
                                    text={
                                        fieldConfig?.Translations?.[i18n.language] || item.Fieldname
                                    }
                                />
                            </Stack>
                            <DateTag
                                date={parseDate(
                                    item.EventTime,
                                    'DD.MM.YYYY HH:mm:ss',
                                ).toISOString()}
                                showTooltipWithTime={true}
                            />
                        </Stack>
                        <Stack direction='row' pl={1}>
                            <GroupedAvatars data={item.Username} />
                        </Stack>
                        <Stack direction='row' spacing={2}>
                            <Icon
                                path={mdiHistory}
                                size={1}
                                style={{ minWidth: '24px' }}
                                color={vars.font}
                            />
                            <span>{item.ValuePrevious}</span>
                        </Stack>
                        <Stack direction='row' spacing={2}>
                            <Icon
                                path={item.ValuePrevious ? mdiArrowRight : mdiNewBox}
                                size={1}
                                color={vars.font}
                                style={{ minWidth: '24px' }}
                            />
                            <span>{item.ValueNew}</span>
                        </Stack>
                    </Stack>
                </ListItem>
            );
        })}
    </List>
);

export interface IActivityLogActivity {
    EventTime: string; // "20.03.2024 13:38:57",
    EventDescription: string; // "Dokument-Nummer geändert von [TEC_IP_00_T_DH_5402_789798_46] auf [TEC_IP_00_T_DH_5402_789798_54]",
    Username: string; // "Max Mustermann - EPLASS GmbH",
    Comment: string; // "Test comment",
    Fieldname: string; // "DocNumber",
    ValuePrevious: string; // "TEC_IP_00_T_DH_5402_789798_46",
    ValueNew: string; // "TEC_IP_00_T_DH_5402_789798_54"
}
